import React from 'react';
import TableWithSummary from '../../../../../../components/table/TableWithSummary';
import { LIST_PAGINATION_MODEL } from '../../../../../../store/modules/app/models';
import {
  BRAND_LIST_FILTER_OPTION_MODEL,
  BRAND_TAG_REQUEST_LIST_SORT_OPTION_MODEL,
} from '../../../../../../store/modules/brand/models';
import { BRAND_TAG_REQUEST_LIST_TABLE_EMPTY_TEXT } from '../../../../../../constants/service/app/brandConstants';
import columns from './columns';

const BrandTagRequestList = (props) => {
  const { brandList, getList, getExcelDownload, getBrandTagColumnTagList } = props;
  const { list, filterOption, sortOption, pagination, summary } = brandList;

  return (
    <div>
      <TableWithSummary
        data={list}
        totalCnt={summary.totalCnt}
        initialOption={{
          filterOption: BRAND_LIST_FILTER_OPTION_MODEL,
          sortOption: BRAND_TAG_REQUEST_LIST_SORT_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        }}
        isStriped={true}
        emptyText={BRAND_TAG_REQUEST_LIST_TABLE_EMPTY_TEXT}
        showPagination
        filterOption={filterOption}
        sortOption={sortOption}
        pagination={pagination}
        getList={getList}
        getExcelDownload={getExcelDownload}
        columns={(utils) =>
          columns({
            getBrandTagColumnTagList,
            ...utils,
          })
        }
      />
    </div>
  );
};

export default BrandTagRequestList;
